/**
 * @ngdoc object
 * @name billing.position_links
 * @description
 *
 */
angular
    .module('festzelt-os.billing.position_links', [
        //'ngListView'
    ]);

// Directives
require('./directives/billable_link/billable_link-directive');
require('./directives/position_links/position_links-directive');

// Factories
require('./factories/position_link-factory');



// WEBPACK FOOTER //
// ./src/app/pages/billing/position_links/position_links-module.js